import { Box } from '@mui/material';

import { MonitoringAnalysisData } from '@/monitoring/utils/processMonitoringData';
import { Plot } from '@/monitoring/plots/Plot';

type MovementAmountProps = {
  data: MonitoringAnalysisData[];
  showIcons: boolean;
  showSubtitle: boolean;
};

export const MovementAmount = ({ data, showIcons, showSubtitle }: MovementAmountProps) => {
  const plotData = data.filter((obj) => obj.activeMobility);

  return (
    <Box sx={{ position: 'relative' }}>
      <Plot
        data={[
          {
            x: plotData.map((val) => val.labelShort),
            y: plotData.map((val) => Number(val.movementShare.toFixed(0))),
            type: 'bar',
            marker: {
              color: plotData.map((obj) => obj.color),
            },
          },
        ]}
        layout={{
          title: `Durchschnittlicher Bewegungsanteil${
            showSubtitle
              ? '<br><sub>Durchschnittliche Bewegungszeit</sub><br><sup>(6 Minuten pro Richtung für Bike + Ride)</sup>'
              : ''
          }`,
          yaxis: { title: 'Aktive Mobilität in Minuten', fixedrange: true },
          xaxis: { fixedrange: true, showticklabels: !showIcons },
          images: showIcons
            ? plotData.map((obj, index) => ({
                source: obj.icon,
                xref: 'paper',
                yref: 'paper',
                x: (index + 0.5) / plotData.length,
                y: -0.02,
                sizex: 0.15,
                sizey: 0.15,
                layer: 'above',
                sizing: 'contain',
                xanchor: 'center',
                yanchor: 'top',
              }))
            : [],
        }}
        useResizeHandler
        style={{ width: '100%', height: '100%', minHeight: '600px' }}
      />
    </Box>
  );
};
